/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { emitCustomTrackingEvent } from '../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';

/**
 *
 * @param {object} salesforceResponse - response from salesforce api
 * @param {boolean} isFireImpression - To fire campaign impression
 * @param {object} page - clickstream page section
 * @returns {trackClickThrough} trackClickThrough - Used to fire clickthrough when product is clicked.
 */
const useClickStreamCustomEventsTracking = ({
    salesforceResponse, isFireImpression, page, experiment,
}) => {
    const dispatch = useDispatch();
    const isFeatureIDAvailable = typeof experiment?.featureId === 'string' && experiment.featureId.length > 0;

    useEffect(() => {
        if (isFireImpression && (salesforceResponse || isFeatureIDAvailable)) {
            dispatch(emitCustomTrackingEvent({
                action: 'Impression',
                salesforceResponse,
                experiment,
                page,
                eventSubType: 'campaign-tracking',
            }));
        }
    }, [salesforceResponse]);

    const trackClickThrough = (partNumber, productFromControl) => {
        if (salesforceResponse || isFeatureIDAvailable) {
            dispatch(emitCustomTrackingEvent({
                action: 'Click',
                partNumber,
                productFromControl,
                salesforceResponse,
                experiment,
                page,
                eventSubType: 'campaign-tracking',
            }));
        }
    };

    return trackClickThrough;
};

export default useClickStreamCustomEventsTracking;
